import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { PowerBiReportPageComponent } from './power-bi-report.component';
import { PowerBiReportViewerModule } from '../../components/power-bi-report-viewer/power-bi-report-viewer.module';
import { IconsModule } from '../../icons/icons.module';

const routes: Routes = [
  {
    path: '',
    component: PowerBiReportPageComponent
  }
];

@NgModule({
  declarations: [PowerBiReportPageComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    PowerBiReportViewerModule,
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    TranslocoModule,
    IconsModule
  ]
})
export class PowerBiReportModule {}
